import { render, staticRenderFns } from "./HotDownload.vue?vue&type=template&id=4b59ae98&scoped=true&"
import script from "./HotDownload.vue?vue&type=script&lang=js&"
export * from "./HotDownload.vue?vue&type=script&lang=js&"
import style0 from "./HotDownload.vue?vue&type=style&index=0&id=4b59ae98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b59ae98",
  null
  
)

export default component.exports